import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 우울 검사 결과 리스트 조회
export function getSurveyDepressionResultFromMomthera({pid}) {
    return AxiosInterceptor({
        url: '/survey/depression/result',
        method: 'get',
        params: {pid}
    })
}

// 불안검사 결과 리스트 조회
export function getSurveyAnxietyResultFromMomthera({pid}){
    return AxiosInterceptor({
        url: '/survey/anxiety/result',
        method: 'get',
        params: {pid}
    })
}